/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2023, Zumper
 */

import type { Listable } from '@zcode/state-type'
import { wordCount } from './wordCount'

export const getShowAmenitiesOrDescription = ({
  isCFR,
  listable,
}: {
  isCFR?: boolean
  listable: Listable
}) => {
  const amenitiesCount = listable.totalAmenitiesLength
  const descriptionWordCount = wordCount(listable.shortDescription)
  let showShortDescription
  let showAmenities

  if (isCFR) {
    showAmenities = amenitiesCount > 0
    showShortDescription = !amenitiesCount && descriptionWordCount > 0
  } else {
    showShortDescription =
      descriptionWordCount >= 15 || (amenitiesCount === 0 && descriptionWordCount > 0)
    showAmenities = !showShortDescription
  }

  return { showAmenities, showShortDescription }
}
